module.exports = __webpack_public_path__ + "static/media/nh_logo.aebd2345.png";